import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const StudentCourses = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await api.get('/student/subjects', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubjects(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur cours:', err);
      setSubjects([]);
    } finally {
      setLoading(false);
    }
  };

  const colors = [
    'bg-[#F39C12]', 'bg-[#3B82F6]', 'bg-[#22C55E]',
    'bg-[#A855F7]', 'bg-[#EF4444]', 'bg-[#06B6D4]'
  ];
  const icons = ['📐', '📖', '🎨', '🌍', '🔬', '💻', '🎵', '⚽'];

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#0A0A0A]">📚 Mes cours</h1>
        <p className="text-gray-500 mt-1">Retrouve ici toutes les matières que tu étudies</p>
      </div>

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : subjects.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center">
          <p className="text-5xl mb-3">📭</p>
          <p className="text-lg font-bold text-[#0A0A0A] mb-2">Aucune matière disponible</p>
          <p className="text-sm text-gray-500">
            Tes matières apparaîtront ici dès qu'elles seront assignées à ta classe.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {subjects.map((subject, idx) => (
            <div
              key={subject.id}
              className="bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-lg hover:border-[#F39C12]/30 transition-all duration-300 group"
            >
              <div className={`w-14 h-14 rounded-xl ${colors[idx % colors.length]} flex items-center justify-center text-white text-2xl mb-4 group-hover:scale-110 transition-transform`}>
                {icons[idx % icons.length]}
              </div>
              <h3 className="font-bold text-[#0A0A0A] text-lg mb-1">
                {subject.name}
              </h3>
              {subject.code && (
                <p className="text-xs text-gray-400 mb-2">Code : {subject.code}</p>
              )}
              {subject.coefficient && (
                <span className="inline-block px-2 py-1 rounded-full text-xs font-medium bg-orange-50 text-[#F39C12]">
                  Coefficient {subject.coefficient}
                </span>
              )}
            </div>
          ))}
        </div>
      )}

      {subjects.length > 0 && (
        <div className="mt-6 bg-orange-50 rounded-2xl p-5 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#F39C12] flex items-center justify-center flex-shrink-0 text-white text-2xl">
            💡
          </div>
          <div>
            <p className="font-bold text-[#0A0A0A] text-base">
              {subjects.length} matière{subjects.length > 1 ? 's' : ''} à étudier
            </p>
            <p className="text-gray-600 text-sm">
              Consulte régulièrement tes cours pour progresser !
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentCourses;